import React, { useEffect } from 'react';
import LandingPageV2 from './LandingPageV2';
import { registerSessionProps } from '../services/analytics';

// WHAT `/` RENDERS: the landing page, from the first paint (#2526).
//
// The flag gate that used to sit here (retired with its flag, #3615) was
// the defect: it rendered the OLD page while the flag read was in flight
// and again as the Suspense fallback while V2's lazy chunk downloaded, so
// every cold load, hard refresh included, showed the retired page and then
// swapped to the new one (founder report, 2026-09-29). So there is no gate
// on `/` and no fallback: LandingPageV2 is imported EAGERLY (it rides the
// main chunk; a lazy import needs a fallback, and any fallback but the page
// itself is a flash). Never reintroduce a V1 fallback or a gate that waits.
// LandingRoute.test.jsx and tests-e2e/landing-first-paint.spec.js pin it.

export default function LandingRoute() {
    // The landing_version session dimension a funnel read segments on. Only
    // one version exists now; it keeps reporting so the series stays whole.
    useEffect(() => {
        registerSessionProps({ landing_version: 'v2' });
    }, []);

    return <LandingPageV2 />;
}
